import { useMutation } from '@tanstack/react-query'

import { disconnectFreeeForAccounting } from '@src/api'
import { DefaultApiDisconnectFreeeForAccountingRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDisconnectFreeeForAccounting = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDisconnectFreeeForAccountingRequest) =>
      disconnectFreeeForAccounting(axiosInstance, params),
  })
}
